import { useEffect, useState } from 'react';
import { Sidebar } from './Sidebar';
import { Gheader } from './Gheader';
import styles from './Document.module.css';
import FilterButton from './FilterButton';
import DocumentTable from './DocumentTable';
import DocumentModel from './DocumentModel';
import apiService from '../api/apiService';
import { ToastContainer } from 'react-toastify';
import { Input } from 'antd';
const { Search } = Input;

export const Document = () => {
  const hotelId = localStorage.getItem('hotel');
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [documentData, setDocumentData] = useState([]);
  const [editingItem, setEditingItem] = useState(null);
  const [guests, setGuests] = useState([]);
  const [searchText, setSearchText] = useState('');
  /* Fetching Documents from API */
  useEffect(() => {
    fetchDocuments();
    fetchGuests();
  }, []);

  const fetchDocuments = async () => {
    try {
      const response = await apiService.get(`/documents/?hotel=${hotelId}`);
      const activeItems = response.filter(a => !a.isArchive);
      console.log(activeItems);
      setDocumentData(activeItems);
    } catch (error) {
      console.error('Error fetching documents:', error);
      setDocumentData([]); // Prevent undefined state
    }
  };

  const fetchGuests = async () => {
    try {
      const response = await apiService.get(`/guests/?hotel=${hotelId}`);
      const activeItems = response.filter(a => !a.isArchive);
      setGuests(activeItems);
    } catch (error) {
      console.error('Error fetching documents:', error);
      setGuests([]);
    }
  };

  const addDocument = newDocument => {
    setDocumentData(prevData => [newDocument, ...prevData]);
  };

  const filteredData = documentData.filter(item => {
    if (!item || !item.guest) return false;

    const guest = guests?.find(g => g.id === item.guest);
    const guestName = guest
      ? guest.name || `${guest.first_name} ${guest.last_name}`
      : '';
    const searchLower = searchText.toLowerCase();

    return (
      guestName.toLowerCase().includes(searchLower) ||
      item.doc_type?.toLowerCase().includes(searchLower) ||
      item.description?.toLowerCase().includes(searchLower)
    );
  });

  return (
    <div className={styles.gheader}>
      <div className={styles.dashboardContainer}>
        <Sidebar />
        <div className={styles.mainContent}>
          <Gheader />
          <h3 className="ps-2 ps-md-0">Documents</h3>
          <div className={`${styles.buttonContainer} ps-2 ps-md-0 `}>
            <button
              className={styles.addRateButton}
              onClick={() => setIsModelOpen(true)}
            >
              Add Document
            </button>
            <Search
              placeholder="input search text"
              allowClear
              enterButton="Search"
              size="medium"
              style={{ width: 300 }}
              onSearch={value => setSearchText(value)}
              onChange={e => setSearchText(e.target.value)}
            />
          </div>

          <DocumentTable
            data={filteredData}
            setData={setDocumentData}
            guests={guests}
            hotelId={hotelId}
            setEditingItem={setEditingItem}
          />

          {isModelOpen && (
            <DocumentModel
              isOpen={isModelOpen}
              onClose={() => setIsModelOpen(false)}
              onSave={addDocument}
              guests={guests}
              hotelId={hotelId}
              existingData={editingItem}
            />
          )}
        </div>
      </div>

      <ToastContainer autoClose={1500} />
    </div>
  );
};

export default Document;
